var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "#6B7280",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1046 11.048C17.7136 10.0101 17.9766 8.80528 17.8556 7.60797C17.6766 5.82397 16.6806 4.24697 15.0526 3.16797L13.9476 4.83397C15.0666 5.57597 15.7476 6.63297 15.8656 7.80797C15.92 8.35407 15.852 8.90543 15.6666 9.42195C15.4811 9.93847 15.1829 10.4072 14.7936 10.794L13.6016 11.986L15.2196 12.461C19.4516 13.701 19.5006 17.957 19.5006 18H21.5006C21.5006 16.211 20.5446 12.715 17.1046 11.048Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12C12.206 12 14 10.206 14 8C14 5.794 12.206 4 10 4C7.794 4 6 5.794 6 8C6 10.206 7.794 12 10 12ZM10 6C11.103 6 12 6.897 12 8C12 9.103 11.103 10 10 10C8.897 10 8 9.103 8 8C8 6.897 8.897 6 10 6ZM11.5 13H8.5C5.191 13 2.5 15.691 2.5 19V20H4.5V19C4.5 16.794 6.294 15 8.5 15H11.5C13.706 15 15.5 16.794 15.5 19V20H17.5V19C17.5 15.691 14.809 13 11.5 13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartners);
export default __webpack_public_path__ + "static/media/partners.e50eca05c745b1b5f954759f841a3046.svg";
export { ForwardRef as ReactComponent };